import { useEffect, useRef } from "react";
import { createStarfield } from "@/lib/starfield";

/**
 * Composant React qui monte un fond étoilé canvas en arrière-plan global.
 * - z-index -1, pointer-events: none, ne casse aucun layout/cliquabilité.
 * - Props : starCount (def. 275), opacity (def. 1), shootingStarFrequency (def. 1)
 */
export default function Starfield({
  starCount = 275,
  opacity = 1,
  shootingStarFrequency = 1,
}) {
  const instanceRef = useRef(null);

  useEffect(() => {
    instanceRef.current = createStarfield({
      container: document.body,
      starCount,
      opacity,
      shootingStarFrequency,
    });
    return () => {
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, [starCount, opacity, shootingStarFrequency]);

  return null;
}
